export const parseFloorplanFilters = (filters, statusesMap) => {
    let typeFilters = []
    let statusFilters = []
    filters.forEach(f => {
        const filterType = f.split('.')[0]
        const filterValue = f.split('.')[1]
        if (filterType === 'status') {
            if (filterValue === 'info') {
                statusFilters.push([...statusesMap[filterValue], 'connected'])
            } else if (filterValue === 'inactive') {
                statusFilters.push([
                    ...statusesMap[filterValue],
                    'disconnected'
                ])
            } else {
                statusFilters.push(statusesMap[filterValue])
            }
        } else if (filterType === 'device_type') {
            typeFilters.push(filterValue)
        }
    })
    return { typeFilters, statusFilters }
}
